'use client'

import { getLocaleUrl } from '@ventanas95dev/runtime/urls'

import { useEffect, useSyncExternalStore, type ReactNode } from 'react'

import { readSavedRegion } from '@/helpers/regionPreference'

const subscribe = () => () => {}
const getServerSnapshot = () => undefined

export function RegionPreferenceGate({
  children,
  supportedRegions,
}: {
  children: ReactNode
  supportedRegions: readonly string[]
}) {
  // The server and first hydration render stay empty until browser cookies are known.
  const slug = useSyncExternalStore<string | null | undefined>(
    subscribe,
    () => {
      try {
        return readSavedRegion(document.cookie, supportedRegions)
      } catch {
        // Show the picker normally when the browser blocks access to cookies.
        return null
      }
    },
    getServerSnapshot,
  )

  useEffect(() => {
    if (!slug) return

    const destination = new URL(
      getLocaleUrl(slug, `/${window.location.search}${window.location.hash}`, {
        origin: window.location.origin,
      }),
      window.location.origin,
    )
    window.location.replace(destination.href)
  }, [slug])

  return slug === null ? children : null
}
